import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callLocationCategoryPost, callLocationCategoryPut, callLocationCategoryViewGet, callLocationCategoryClearView } from "../../actions/locationCategories"

let LocationCategoryEdit = ({ setPageAttr, methods: { callLocationCategoryPost, callLocationCategoryViewGet, callLocationCategoryPut, callLocationCategoryClearView }, view }) => {
    const params = useParams()
    const [id] = useState(!params.id ? '' : params.id)
    const [name, setName] = useState('')

    useEffect(() => {
        callLocationCategoryClearView()
        let tabs
        if (!id) {
            tabs = [
                {
                    active: false,
                    to: '/location-categories',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/location-categories/add',
                    label: 'Adicionar'
                }
            ]
        } else {
            callLocationCategoryViewGet(id)
            tabs = [
                {
                    active: false,
                    to: '/location-categories',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/location-categories/edit/' + id,
                    label: 'Editar'
                }
            ]
        }

        setPageAttr({
            title: 'Tipo de Local - ' + (!id ? 'Novo' : 'Editar'),
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, id, callLocationCategoryViewGet, callLocationCategoryClearView])

    useEffect(() => {
        setName(view.name)
    }, [view, setName])

    const finishedSubmit = () => {
        setName('')
        window.navigate('/location-categories')
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            name: name
        }

        if (!id) {
            callLocationCategoryPost(data, () => finishedSubmit())
        } else {
            callLocationCategoryPut(id, data, () => finishedSubmit())
        }
    }

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-6 form-group">
                    <label className="required">Nome da Categoria:</label>
                    <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                </div>
            </div>
            <div className="clearfix text-left mt-3">
                <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-save fa-white"></i>Salvar</button>
                <Link to={'/location-categories'} className="btn btn-secondary ml-3"><i className="fas fa-arrow-left mr-1"></i>Voltar</Link>
            </div>
        </form>
    )
}

const mapStateToProps = ({ config: { locationCategories: { view } } }) => ({
    view: view,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callLocationCategoryViewGet,
            callLocationCategoryPost,
            callLocationCategoryClearView,
            callLocationCategoryPut
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationCategoryEdit)